import { ActionType, getType } from 'typesafe-actions';

import * as termsAgreementActions from './actions';
import { PendingTermsAgreementTypes, TermsListTypes } from './types';

type TermsAgreementActionType = ActionType<typeof termsAgreementActions>;

export interface TermsAgreementState {
  termsAgreementCount: {
    data: number | null;
    loading: boolean;
  };
  termsAgreement: {
    data: PendingTermsAgreementTypes[];
    loading: boolean;
  };
  termsAgreementAccept: {
    loading: boolean;
  };
  terms: {
    data: TermsListTypes[];
    loading: boolean;
  };
}

const initialState: TermsAgreementState = {
  termsAgreementCount: {
    data: null,
    loading: false,
  },
  termsAgreement: {
    data: [],
    loading: false,
  },
  termsAgreementAccept: {
    loading: false,
  },
  terms: {
    data: [],
    loading: false,
  },
};

const termsAgreementReducer = (
  state: TermsAgreementState = initialState,
  action: TermsAgreementActionType,
): TermsAgreementState => {
  switch (action.type) {
    //terms aggrement count
    case getType(termsAgreementActions.pendingTermsAgreementCount.request):
      return {
        ...state,
        termsAgreementCount: {
          ...state.termsAgreementCount,
          loading: true,
        },
      };
    case getType(termsAgreementActions.pendingTermsAgreementCount.success):
      return {
        ...state,
        termsAgreementCount: {
          ...state.termsAgreementCount,
          data: action.payload.data.count,
          loading: false,
        },
      };
    case getType(termsAgreementActions.pendingTermsAgreementCount.failure):
      return {
        ...state,
        termsAgreementCount: {
          ...state.termsAgreementCount,
          loading: false,
        },
      };

    //pending terms aggrement
    case getType(termsAgreementActions.pendingTermsAgreement.request):
      return {
        ...state,
        termsAgreement: {
          ...state.termsAgreement,
          loading: true,
        },
      };
    case getType(termsAgreementActions.pendingTermsAgreement.success):
      return {
        ...state,
        termsAgreement: {
          ...state.termsAgreement,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(termsAgreementActions.pendingTermsAgreement.failure):
      return {
        ...state,
        termsAgreement: {
          ...state.termsAgreement,
          loading: false,
        },
      };

    //Terms Agreement accept
    case getType(termsAgreementActions.termsAgreementAccept.request):
      return {
        ...state,
        termsAgreementAccept: {
          ...state.termsAgreementAccept,
          loading: true,
        },
      };
    case getType(termsAgreementActions.termsAgreementAccept.success):
      return {
        ...state,
        termsAgreementAccept: {
          ...state.termsAgreementAccept,
          loading: false,
        },
      };
    case getType(termsAgreementActions.termsAgreementAccept.failure):
      return {
        ...state,
        termsAgreementAccept: {
          ...state.termsAgreementAccept,
          loading: false,
        },
      };

    //Terms
    case getType(termsAgreementActions.termsLists.request):
      return {
        ...state,
        terms: {
          ...state.terms,
          loading: true,
        },
      };
    case getType(termsAgreementActions.termsLists.success):
      return {
        ...state,
        terms: {
          ...state.terms,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(termsAgreementActions.termsLists.failure):
      return {
        ...state,
        terms: {
          ...state.terms,
          loading: false,
        },
      };

    case getType(termsAgreementActions.clearTermsAgreement):
      return initialState;

    default:
      return state;
  }
};

export default termsAgreementReducer;
